import type { DocsV1Read } from "../../client";

export const DEFAULT_DARK_MODE_ACCENT_PRIMARY: DocsV1Read.RgbaColor = {
    r: 129,
    g: 140,
    b: 248,
    a: undefined
};

export const DEFAULT_LIGHT_MODE_ACCENT_PRIMARY: DocsV1Read.RgbaColor = {
    r: 129,
    g: 140,
    b: 248,
    a: undefined
};
